/*-----------------------------------------------------------------
- Button translations
-----------------------------------------------------------------*/
export default {

    accept   : 'تایید',
    cancel   : 'انصراف',
    next     : 'بعدی',
    back     : 'قبلی',
    finish   : 'پایان',
    load_more: 'مطالب بیشتر',

};
